import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import NewsDetail from "@/pages/NewsDetail.vue";

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/representatives',
    name: 'representatives',
    component: () => import( '../views/RepresentativesView.vue')
  },
  {
    path: '/documents',
    name: 'documents',
    component: () => import( '../views/DocumentsView.vue')
  },
  {
    path: '/projects/dom-miloserdija',
    name: 'house-of-mercy',
    component: () => import( '../views/projects/HouseOfMercyView.vue')
  },
  {
    path: '/partners',
    name: 'partners',
    component: () => import( '../views/PartnerView.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import( '../pages/NewsList.vue')
  },
  {
    path: '/news/:slug',
    component: NewsDetail,
    props: true
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import( '../views/ContactView.vue')
  },
  {
    path: '/help',
    name: 'help',
    component: () => import( '../views/HelpView.vue')
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import( '../views/PolicyView.vue')
  },
  {
    path: '/projects/masterskaya-vzrosloy-zhizny',
    name: 'workshop',
    component: () => import( '../views/projects/WorkshopView.vue')
  },
  {
    path: '/projects/malenkije-radosty',
    name: 'little-joys',
    component: () => import( '../views/projects/LittleJoysView.vue')
  },
  {
    path: '/form',
    name: 'form',
    component: () => import( '../views/FormView.vue')
  },
  {
    path: '/reports/itogi-raboti',
    name: 'itogi-raboti',
    component: () => import('@/pages/ItogiRaboti.vue')
  },
  {
    path: '/reports/:slug',
    name: 'report-detail',
    component: () => import('@/pages/ReportDetail.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
